import { Box } from 'styled-system/jsx';
import { CardSquareTypes } from '@/common/components/cardSquare/CardSquare.types.ts';
import Typography from '@/common/components/base/typography/Typography.tsx';

const CardSquare = ({
  title,
  renderIcon,
  onClick,
  disabled = true,
}: CardSquareTypes) => {
  return (
    <Box
      bgColor="white"
      display="flex"
      flexDir="column"
      alignItems="center"
      p="10px"
      borderRadius="8px"
      gap="8px"
      cursor={disabled ? 'pointer' : 'not-allowed'}
      onClick={disabled ? onClick : undefined}
    >
      <Box pt="8px">{renderIcon?.()}</Box>
      <Typography color={disabled ? 'black-1' : 'gray'} textStyle="b4">
        {title}
      </Typography>
    </Box>
  );
};

export default CardSquare;
